import React, { useState } from 'react';
import { Input } from 'antd';
import {
	SendOutlined,
	AudioOutlined,
	AlignCenterOutlined,
} from '@ant-design/icons';
import styled from 'styled-components';

const InputWrapper = styled.div`
	position: relative;
	width: 100%;
`;

const StyledInput = styled(Input)`
	padding: 12px 96px 12px 16px;
	font-size: 16px;
	height: auto;
	background: ${({ theme }) => theme.CQColors.white} !important;
	border: 1px solid rgba(0, 0, 0, 0.05) !important;
	backdrop-filter: blur(21px);
	border-radius: 10px;

	&:hover,
	&:focus {
		border-color: ${({ theme }) =>
			theme.CQColors.secondaryColor} !important;
		box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
	}

	&::placeholder {
		color: ${({ theme }) => theme.CQColors.primaryColor};
		opacity: 0.4;
	}
`;

const IconButton = styled.button`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: all 0.3s ease;
	color: white;
	padding: 0;
	background: ${({ theme }) => theme.CQColors.gradientBg} !important;
	border: 1px solid ${({ theme }) => theme.CQColors.white};
	box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
	border-radius: 10px;

	&:hover {
		&:hover {
			background: transparent;
			color: ${({ theme }) => theme.CQColors.gradientBg} !important;
		}
		transform: translateY(-50%) scale(1.05);
	}

	&:disabled {
		background: #d9d9d9 !important;
		cursor: not-allowed;
		transform: translateY(-50%);
		&:hover {
			background: #d9d9d9 !important;
		}
	}

	svg {
		width: 16px;
		height: 16px;
	}
`;

const SendButton = styled(IconButton)`
	right: 8px;
	svg {
		rotate: -45deg;
	}
	&:hover {
		background: ${({ theme }) => theme.CQColors.gradientBg} !important;
		color: ${({ theme }) => theme.CQColors.white} !important;
	}
`;

const MicButton = styled(IconButton)`
	right: 48px;
	background: transparent;
	border: none;
	box-shadow: none;
	color: ${({ theme }) => theme.CQColors.secondaryColor};
	svg {
		rotate: 270deg;
	}
`;

const AIInput = ({ onSubmit }) => {
	const [value, setValue] = useState('');

	const handleSubmit = () => {
		if (value.trim()) {
			onSubmit(value);
			setValue('');
		}
	};

	const handleKeyPress = (e) => {
		if (e.key === 'Enter') {
			handleSubmit();
		}
	};

	const handleVoiceInput = () => {
		// Voice input functionality can be implemented here
		console.log('Voice input clicked');
	};

	return (
		<InputWrapper>
			<StyledInput
				placeholder="Type to get started"
				value={value}
				onChange={(e) => setValue(e.target.value)}
				onKeyPress={handleKeyPress}
			/>
			{/* <MicButton onClick={handleVoiceInput}>
				<AlignCenterOutlined />
			</MicButton> */}
			<SendButton onClick={handleSubmit} disabled={!value.trim()}>
				<SendOutlined />
			</SendButton>
		</InputWrapper>
	);
};

export default AIInput;
